import { nullableUuidString } from '../../zod-helpers/index.js';
export const deliveryDriverUserIdSchema = nullableUuidString('Invalid driver selection.');
//# sourceMappingURL=delivery-driver-user-id-schema.js.map